export default __webpack_public_path__ + "static/media/Q_sound.3d85212b.mp3";